import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, forkJoin, of, Subject } from "rxjs";
import { map, mergeMap } from "rxjs/operators";
import {
	AssetRuleApiParams,
	AssetRulePatchAddRuleBody,
	AssetRulePatchBody,
	AssetRulePatchRemoveRuleBody,
} from "src/app/models/mir-rule.model";
import { environment } from "src/environments/environment";
import { RequestService } from "../request/request.service";

@Injectable({
	providedIn: "root",
})
export class AssetRulesService {
	constructor(private requestService: RequestService) {}

	confirmClearRule$ = new Subject();
	confirmAssignRule$: BehaviorSubject<string> = new BehaviorSubject(null);
	confirmCancelAssignRule$ = new Subject();
	getAssets(body: AssetRuleApiParams) {
		const url = `${environment.environmentConstants.APP_ENDPOINT_EVIR_V2}/assets/rules?page=${body.page}&perPage=${body.perPage}&sort=${body.sort}&sortDir=${body.sortDir}`;
		return this.requestService.post<HttpResponse<AssetRuleApiParams[]>>({
			url,
			httpOptions: { observe: "response" },
			data: body,
		});
	}

	getAllAssets(body?: AssetRuleApiParams) {
		let assets: AssetRuleApiParams[] = [];
		let params: AssetRuleApiParams = {
			page: "1",
			perPage: "1000",
			sort: "ruleName",
			sortDir: "asc",
		};

		if (body) {
			params = {
				...body,
				...params,
			};
		}

		return this.getAssets(params).pipe(
			mergeMap(response => {
				const totalPages = parseInt(response.headers.get("X-Page-Count"));
				assets = response.body;

				if (totalPages > 1) {
					const obs = [];
					for (let i = 2; i <= totalPages; i++) {
						params.page = i.toString();
						obs.push(this.getAssets(params));
					}

					return forkJoin(obs).pipe(
						map(res => {
							res.forEach(r => {
								(r as any).body.forEach(item => {
									assets.push(item);
								});
							});

							return assets;
						}),
					);
				}
				return of(assets);
			}),
		);
	}

	patchRuleAssets(
		companyId: string,
		removedAssets: AssetRulePatchRemoveRuleBody = null,
		addedAssets: AssetRulePatchAddRuleBody = null,
	) {
		const url = `${environment.environmentConstants.APP_ENDPOINT_EVIR_V2}/rules/assets`;

		const body = new AssetRulePatchBody(companyId, removedAssets, addedAssets).body;

		return this.requestService.patch({
			url,
			data: body,
		});
	}
}
